import { EntityEnum, getEntityEnumDescription, StatusInformationSeverityEnum, IntegrationSourceEnum } from '@c2b/muven-commons';

export class ServiceStatusInformationModel {
    hasReadConfirmation: boolean = false;
    entity: EntityEnum;
    entityDescription?: string = "";
    status: StatusInformationSeverityEnum;
    source: IntegrationSourceEnum;
    description: string = "";
    message: string = "";
    link: string = "";

    constructor(d?: Partial<ServiceStatusInformationModel>) {
        Object.assign(this, d);
        this.entityDescription = getEntityEnumDescription(this.entity);
    }

    isLinkExternal():boolean {
        return /^https?/.test(this.link)
    }

    isStatusInfo():boolean {
        return this.status === StatusInformationSeverityEnum.Info;
    }

    isStatusNormal():boolean {
        return this.status === StatusInformationSeverityEnum.Normal;
    }

    isStatusWarning():boolean {
        return this.status === StatusInformationSeverityEnum.Warning;
    }

    isStatusNotWorking():boolean {
        return this.status === StatusInformationSeverityEnum.NotWorking;
    }

    isSourceBackend():boolean {
        return this.source === IntegrationSourceEnum.Backend;
    }

    isSourceAdmin():boolean {
        return this.source === IntegrationSourceEnum.Admin;
    }

    isSourceChannel():boolean {
        return this.source === IntegrationSourceEnum.Channel;
    }

    hasLink():boolean {
        return !!this.link
    }

    // Alertas de canal apontam para /canais/{id}/...: é por aí que achamos a marca do canal.
    getChannelId():string | null {
        const match = /^\/canais\/([^/?#]+)/.exec(this.link || '')

        return match ? match[1] : null
    }
}
